import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link, useNavigate } from 'react-router-dom'; // useNavigate ekledik
import FerdiKazaSeo from './FerdiKazaSeo';

const FerdiKaza = () => {
    const navigate = useNavigate();
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false); // Loading state'i ekledik
    
    const [formData, setFormData] = useState({
      tc: '',
      teminatTutari: '',
      telefon: '',
      kvkk: true
    });
  
    const [validationErrors, setValidationErrors] = useState({});

  const agents = [
    { name: 'Melisa', title: 'Ferdi Kaza Uzmanı', image: '👩‍💼', testimonial: "Size özel teminat tutarını belirleyelim." },
    { name: 'Burak', title: 'Sigorta Danışmanı', image: '👨‍💼', testimonial: "Güvenceniz için en uygun teklifi sunalım." },
    { name: 'Ayşe', title: 'Ferdi Kaza Uzmanı', image: '👩‍💼', testimonial: "Risklere karşı sizi koruyalım." },
    { name: 'Emre', title: 'Ferdi Kaza Danışmanı', image: '👨‍💼', testimonial: "7/24 yanınızdayız." }
  ];

  const [activeAgent, setActiveAgent] = useState(0);

  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * agents.length);
    setActiveAgent(randomIndex);

    const timer = setInterval(() => {
      setActiveAgent((prev) => (prev + 1) % agents.length);
    }, 3000);

    return () => clearInterval(timer);
  }, []);

  const validateForm = () => {
    const errors = {};
    
    if (!formData.tc || formData.tc.length !== 11 || !/^\d+$/.test(formData.tc)) {
      errors.tc = 'Geçerli bir TC Kimlik Numarası giriniz';
    }

    if (!formData.teminatTutari) {
      errors.teminatTutari = 'Lütfen teminat tutarını seçiniz';
    }

    const phoneRegex = /^[0-9]{10,11}$/;
    if (!formData.telefon || !phoneRegex.test(formData.telefon.replace(/\D/g, ''))) {
      errors.telefon = 'Geçerli bir telefon numarası giriniz';
    }

    if (!formData.kvkk) {
      errors.kvkk = 'KVKK metnini kabul etmelisiniz';
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
  
    setLoading(true);
    setError('');
  
    try {
      const response = await fetch(`${window.location.protocol}//${window.location.host}/ferdi-kaza.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(formData)
      });
  
      const data = await response.json();
  
      if (!response.ok) {
        throw new Error(data.message || 'Bir hata oluştu');
      }
  
      // Başarılı durumda teşekkür sayfasına yönlendir
      navigate(`/tesekkurler?teklifKodu=${data.teklifKodu}`);
  
    } catch (err) {
      setError(err.message);
      console.error('Form gönderme hatası:', err);
    } finally {
      setLoading(false);
    }
  };

  const teminatOptions = [
    { value: '100000', label: '100.000 TL', description: 'Temel Koruma' },
    { value: '250000', label: '250.000 TL', description: 'Standart Koruma' },
    { value: '500000', label: '500.000 TL', description: 'Gelişmiş Koruma' },
    { value: '1000000', label: '1.000.000 TL', description: 'Tam Koruma' },
    { value: 'undecided', label: 'Karar Vermedim', description: 'Uzmanımız sizi arayıp bilgi versin' }
  ];

  return (
    <div className="overflow-x-hidden">
      <Helmet>
        <title>Ferdi Kaza Sigortası - En Uygun Fiyatlarla | SigortamOlsun</title>
        <meta name="description" content="En uygun ferdi kaza sigortası tekliflerini anında karşılaştırın." />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>

      <div className="px-4 py-8">
        <div className="max-w-md mx-auto">
          {/* Agent Kartları */}
          <div className="relative h-32 mb-4">
            {agents.map((agent, index) => (
              <div
                key={agent.name}
                className={`absolute w-full transition-all duration-500 transform
                  ${index === activeAgent ? 'scale-100 opacity-100' : 'scale-75 opacity-0'}
                  flex items-center gap-3 bg-blue-50 p-4 rounded-xl shadow-md border-2 border-blue-200`}
                style={{
                  transform: `translateX(${(index - activeAgent) * 100}%) scale(${index === activeAgent ? 1 : 0.75})`,
                  zIndex: index === activeAgent ? 10 : 0
                }}
              >
                <span className="text-2xl sm:text-3xl flex-shrink-0">{agent.image}</span>
                <div className="min-w-0 flex-1">
                  <div className="font-semibold text-blue-900">{agent.name}</div>
                  <div className="text-sm text-blue-600">{agent.title}</div>
                  <div className="text-sm italic text-gray-500 break-words">{agent.testimonial}</div>
                </div>
              </div>
            ))}
          </div>

          {/* SEO Başlık ve Açıklama */}
<div className="text-center mb-8">
  <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3">
    Ferdi Kaza Sigortası
  </h1>
  <p className="text-base text-gray-600">
    En uygun ferdi kaza sigortası fiyatı almak için bilgilerinizi giriniz.
  </p>
</div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-6">
          <div>
  <label className="block text-sm font-medium text-gray-700 mb-1">
    TC Kimlik Numaranız
  </label>
  <input
    type="tel"
    inputMode="numeric"
    placeholder="TC Kimlik Numarası"
    className={`w-full p-3 border rounded focus:outline-none focus:ring-2 focus:ring-blue-600
      ${validationErrors.tc ? 'border-red-500' : 'border-gray-300'}`}
    maxLength="11"
    value={formData.tc}
    onChange={(e) => {
      const value = e.target.value.replace(/\D/g, '');
      setFormData({ ...formData, tc: value });
      if (validationErrors.tc) setValidationErrors({ ...validationErrors, tc: '' });
    }}
  />
  {validationErrors.tc && (
    <p className="mt-1 text-sm text-red-600">{validationErrors.tc}</p>
  )}
</div>

            {/* Teminat Tutarı Seçimi */}
         
<div className="space-y-3">
  <div className="text-sm font-medium text-gray-700 mb-2">Teminat Tutarı Seçiniz</div>
  
  {/* İlk 4 teminat tutarı için 2x2 grid */}
  <div className="grid grid-cols-2 gap-3 mb-3">
    {teminatOptions.slice(0, 4).map((option) => (
      <label
        key={option.value}
        className={`flex flex-col p-3 border rounded-lg cursor-pointer transition-colors
          ${formData.teminatTutari === option.value 
            ? 'bg-blue-50 border-blue-500' 
            : 'hover:bg-gray-50 border-gray-200'}`}
      >
        <input
          type="radio"
          name="teminatTutari"
          value={option.value}
          checked={formData.teminatTutari === option.value}
          onChange={(e) => setFormData({ ...formData, teminatTutari: e.target.value })}
          className="hidden"
        />
        <div className="text-center">
          <div className="font-medium text-gray-900">{option.label}</div>
          <div className="text-sm text-gray-500">{option.description}</div>
        </div>
        <div className={`w-4 h-4 rounded-full border-2 mx-auto mt-2 flex items-center justify-center
          ${formData.teminatTutari === option.value 
            ? 'border-blue-500 bg-blue-500' 
            : 'border-gray-300'}`}
        >
          {formData.teminatTutari === option.value && (
            <div className="w-1.5 h-1.5 rounded-full bg-white" />
          )}
        </div>
      </label>
    ))}
  </div>

  {/* Son teminat tutarı (Karar Vermedim) için tam genişlik */}
  <label
    className={`flex items-center p-4 border rounded-lg cursor-pointer transition-colors w-full
      ${formData.teminatTutari === teminatOptions[4].value 
        ? 'bg-blue-50 border-blue-500' 
        : 'hover:bg-gray-50 border-gray-200'}`}
  >
    <input
      type="radio"
      name="teminatTutari"
      value={teminatOptions[4].value}
      checked={formData.teminatTutari === teminatOptions[4].value}
      onChange={(e) => setFormData({ ...formData, teminatTutari: e.target.value })}
      className="hidden"
    />
    <div className="ml-3 flex-1">
      <div className="font-medium text-gray-900">{teminatOptions[4].label}</div>
      <div className="text-sm text-gray-500">{teminatOptions[4].description}</div>
    </div>
    <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center
      ${formData.teminatTutari === teminatOptions[4].value 
        ? 'border-blue-500 bg-blue-500' 
        : 'border-gray-300'}`}
    >
      {formData.teminatTutari === teminatOptions[4].value && (
        <div className="w-2 h-2 rounded-full bg-white" />
      )}
    </div>
  </label>
</div>

<div>
  <label className="block text-sm font-medium text-gray-700 mb-1">
    Telefon Numaranız
  </label>
  <input
    type="tel"
    placeholder="Telefon Numarası"
    className={`w-full p-3 border rounded focus:outline-none focus:ring-2 focus:ring-blue-600
      ${validationErrors.telefon ? 'border-red-500' : 'border-gray-300'}`}
    value={formData.telefon}
    onChange={(e) => {
      const value = e.target.value.replace(/\D/g, '');
      setFormData({ ...formData, telefon: value });
      if (validationErrors.telefon) setValidationErrors({ ...validationErrors, telefon: '' });
    }}
  />
  {validationErrors.telefon && (
    <p className="mt-1 text-sm text-red-600">{validationErrors.telefon}</p>
  )}
</div>

            <div className="flex items-start gap-2">
              <input
                type="checkbox"
                checked={formData.kvkk}
                onChange={(e) => setFormData({ ...formData, kvkk: e.target.checked })}
                className={`mt-1 ${validationErrors.kvkk ? 'border-red-500' : ''}`}
              />
              <label className="text-sm text-gray-600">
                <Link to="/kvkk" className="text-blue-600 hover:text-blue-700">KVKK</Link>
                {' ve '}
                <Link to="/aydinlatma-metni" className="text-blue-600 hover:text-blue-700">site kullanım koşullarını</Link>
                {' kabul ediyorum'}
              </label>
            </div>
            {validationErrors.kvkk && (
              <p className="text-sm text-red-600">{validationErrors.kvkk}</p>
            )}

            <button
              type="submit"
              className="w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 transition"
            >
              Fiyat Al
            </button>
          </form>
        </div>
      </div>
      <FerdiKazaSeo />
    </div>
  );
};

export default FerdiKaza;